@if (isAccountValidated) {
  <div class="flex flex-column gap-3 pt-2">
    <form [formGroup]="otpForm" class="flex flex-column gap-2">
      <span class="text-sm font-medium"><app-translate key="SEND_PIN_VIA"></app-translate></span>
      @if (pinDeliveryOptions.email) {
        <label class="flex align-items-center gap-2">
          <p-radioButton name="deliveryMethod" value="email" inputId="deliveryMethodEmail"
            formControlName="deliveryMethod"
          (onClick)="selectPinDeliveryMethod('email')"></p-radioButton>
          <span class="text-sm font-normal text-color cursor-pointer">Email
          {{ maskEmail(pinDeliveryOptions.email) }}</span>
        </label>
      }
      @for (ctn of pinDeliveryOptions.ctnOptions; track ctn; let i = $index) {
        <label class="flex align-items-center gap-2"
          >
          <p-radioButton name="deliveryMethod" [value]="ctn" [inputId]="'deliveryMethodCtn' + i"
            formControlName="deliveryMethod"
          (onClick)="selectPinDeliveryMethod(ctn)"></p-radioButton>
          <span class="text-sm font-normal text-color cursor-pointer">Text
          ....{{ ctn.slice(-4) }}</span>
        </label>
      }
    </form>
    @if (pinSentSuccess && resendCooldownSeconds > 0) {
      <app-success-banner
      [message]="languageService.getTranslation('CODE_SENT_SUCCESS_MESSAGE')"></app-success-banner>
    }
    @if (step2ErrorType === 'expired') {
      <app-error-banner
        [title]="languageService.getTranslation('PIN_EXPIRED_TITLE')"
      [message]="languageService.getTranslation('PIN_EXPIRED_MESSAGE')"></app-error-banner>
    }
    @if (step2ErrorType === 'notDelivered') {
      <app-error-banner
        [title]="languageService.getTranslation('PIN_NOT_DELIVERED_TITLE')"
      [message]="languageService.getTranslation('PIN_NOT_DELIVERED_MESSAGE')"></app-error-banner>
    }
    @if (showSendPinButton) {
      <div>
        <p-button [styleClass]="'button-secondary'"
          [label]="languageService.getTranslation(sendButtonLabelKey())"
          [disabled]="!selectedPinDeliveryMethod || (pinSentSuccess && resendCooldownSeconds > 0)"
        (click)="sendPinClicked()" [outlined]="true"></p-button>
        @if (pinSentSuccess && resendCooldownSeconds > 0) {
          <div class="text-xs text-color-secondary mt-1">
            {{ languageService.getTranslation('RESEND_COOLDOWN_PREFIX') }}
            {{ resendCooldownSeconds }}
            {{ languageService.getTranslation('RESEND_COOLDOWN_SUFFIX') }}
          </div>
        }
      </div>
    }
  </div>
}